// extracted by mini-css-extract-plugin
export default {"container":"SA5t","header":"_3Una","heading":"_3SxZ","icons":"_1jlZ","smalltext":"GP5-"};